var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconXLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11.647 8.469 18.932 0h-1.726L10.88 7.353 5.827 0H0l7.64 11.12L0 20h1.726l6.68-7.765L13.744 20h5.827zm-2.365 2.748-.774-1.107-6.16-8.81H5l4.971 7.11.774 1.107 6.462 9.242h-2.652z"
})));
export default SvgIconXLogo;